import { apiClient } from './api';
import {
  Customer,
  CreateCustomerRequest,
  UpdateCustomerRequest,
  CreateDownloadTokenRequest,
  UpdateDownloadTokenRequest,
  CustomerDownloadToken,
  AllDownloadStatisticsResponse,
} from '../types/api';

export const customerService = {
  getAll: async (includeInactive = false): Promise<Customer[]> => {
    const { data } = await apiClient.get('/customers', {
      params: { includeInactive },
    });
    return data;
  },

  getById: async (id: number): Promise<Customer> => {
    const { data } = await apiClient.get(`/customers/${id}`);
    return data;
  },

  search: async (query: string): Promise<Customer[]> => {
    const { data } = await apiClient.get('/customers/search', {
      params: { query },
    });
    return data;
  },

  create: async (request: CreateCustomerRequest): Promise<Customer> => {
    const { data } = await apiClient.post('/customers', request);
    return data;
  },

  update: async (id: number, request: UpdateCustomerRequest): Promise<Customer> => {
    const { data } = await apiClient.put(`/customers/${id}`, request);
    return data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/customers/${id}`);
  },

  // Token management
  createToken: async (
    customerId: number,
    request: CreateDownloadTokenRequest
  ): Promise<CustomerDownloadToken> => {
    const { data } = await apiClient.post(`/customers/${customerId}/tokens`, request);
    return data;
  },

  updateToken: async (
    customerId: number,
    tokenId: number,
    request: UpdateDownloadTokenRequest
  ): Promise<CustomerDownloadToken> => {
    const { data } = await apiClient.put(
      `/customers/${customerId}/tokens/${tokenId}`,
      request
    );
    return data;
  },

  deleteToken: async (customerId: number, tokenId: number): Promise<void> => {
    await apiClient.delete(`/customers/${customerId}/tokens/${tokenId}`);
  },

  // Admin statistics
  getAllDownloadStatistics: async (days = 30, customerId?: number): Promise<AllDownloadStatisticsResponse> => {
    const { data } = await apiClient.get('/blacklist/admin/download-statistics', {
      params: { days, customerId },
    });
    return data;
  },
};
